import { Box, Button, Typography } from "@mui/material"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getProductListAction } from "../../asyncActions/productAction"
import { DataGrid } from "@mui/x-data-grid"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import SubmitButton from "../../UI/SubmitButton"
import { setModal } from "../../store/modalSlice"





function ProductManagePage(){

    const dispatch = useDispatch()

    const {t} = useTranslation()

    const {
        productList
    } = useSelector((store => store.product.product))

    
    const {
        dataLoad
    } = useSelector((store => store.product))


    useEffect(() => {
        dispatch(getProductListAction())
    }, [dispatch])

    const rows = productList.map((product) => ({
        id: product.id,
        category_name: product.category.name,
        unit_type: product.unit_type,
        name: product.name,
    }))
    
    const columns = [
       {
            field: 'category_name',
            headerName: t('grid.category'),
            editable: false,
            minWidth: 100,
            flex: 1,
        },
        { field: 'id', headerName: 'ID', maxWidth: 100, flex: 1 },
        {
            field: 'name',
            headerName: t('grid.product_name'),
            rowSpanValueGetter: () => { },
            editable: false,
            minWidth: 250,
            flex: 1,
        },
        {
            field: 'unit_type',
            headerName: t('grid.unit_type'),
            rowSpanValueGetter: () => { },
            editable: false,
            minWidth: 80,
            flex: 1,
        },
        {
            field: 'Action',
            headerName: t('grid.action'),
            rowSpanValueGetter: () => { },
            editable: false,
            maxWidth: 80,
            flex: 1,
            renderCell: (params) => {
                const {id} = params.row

                return (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <Link to={'/product/edit/'+id}>
                            <Button variant='outlined' color={'info'}>Edit</Button>                        
                        </Link>
                    </Box>
                )
            }
        }
    ]

    const handleCreateCategory = () => {
        const modalPayload = {
            active: true,
            content: 'categoryCreate'
        }
        dispatch(setModal(modalPayload))
    }


    return (
        <Box sx={{
            width: '100%',
        }}>
            <Typography align="center" variant="h4">Product manage</Typography>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 2,
                p: 2
            }}>
                <Link to={'/product/create'}>
                    <SubmitButton>Create new product</SubmitButton>
                </Link>
                <SubmitButton onClick={handleCreateCategory}>Create new category</SubmitButton>
            </Box>  
            <Box>
            <DataGrid
                rows={rows}
                columns={columns}
                loading={dataLoad}
                unstable_rowSpanning
                showCellVerticalBorder
            />
            </Box>
        </Box>
    )
}


export default ProductManagePage